<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="90px" :model="searchForm" ref="searchForm">
          <el-form-item label="商品编码" prop="skuCode">
            <el-input v-model.trim="searchForm.skuCode" placeholder="请输入商品编码"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="skuName">
            <el-input v-model.trim="searchForm.skuName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="是否清仓">
            <el-select v-model="searchForm.clearance" placeholder="全部">
              <el-option label="全部" value="">全部</el-option>
              <el-option label="是" value="是">是</el-option>
              <el-option label="否" value="否">否</el-option>
              <el-option label="-" value="-">-</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="更新时间">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="onDateRangeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="标签">
            <el-select v-model="searchForm.changeFlag" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="新增" value="0" />
              <el-option label="变更" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否组合">
            <el-select v-model="searchForm.isCombination" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="是" value="Y" />
              <el-option label="否" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item label="销售状态">
            <el-select v-model="searchForm.saleStatusList" placeholder="全部" multiple collapse-tags clearable @change="saleStatusListChange">
              <el-option label="全部" value="" v-show="!all"></el-option>
              <el-option label="取消所有" value="cancleAll" v-if="all"></el-option>
              <el-option :label="item" :value="item" v-for="(item, index) in saleStatusList" :key="index" />
            </el-select>
          </el-form-item>
          <el-form-item label="达播状态">
            <el-select v-model="searchForm.boolLimit" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="释放" value="释放" />
              <el-option label="控价中" value="控价中" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" @click="searchPage" class="green-btn" size="mini">搜索</el-button>
          <el-button @click="resetForm" class="orange-btn" size="mini">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-badge :value="`变更${isShowNew}`" class="badge_align" :hidden="!isShowNew" style="margin-right: 10px;">
          <el-button size="mini" class="orange-btn" @click="getInventoy">变更清单</el-button>
        </el-badge>
        <el-button type="primary" size="mini" @click="importExcel">直播价导入</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        border
        ref="table"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        :height="maxTableHeight"
        :data="tableData.list"
        v-if="tableReload"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :span-method="handleSpanMethod"
        style="width: 100%"
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width"
          :sortable="item.sortable ? 'custom' : false"
          :align="item.align"
          :fixed="item.fixed"
          show-overflow-tooltip
          v-for="item in columnData"
          :key="item.prop"
        >
          <template slot-scope="scope">
            <template v-if="item.label == '图片'">
              <el-button v-if="scope.row.imgUrlList.length" size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>
            </template>
            <template v-else-if="item.label == '有效期'">
              <span>{{ scope.row.validtyStart }}<span v-if="scope.row.validtyStart && scope.row.validtyEnd">至</span>{{ scope.row.validtyEnd }}</span>
            </template>
            <template v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column width="210" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="lookRecord(scope.row)">查看调整记录</el-link>
            <el-link type="primary" :underline="false" @click="lookLivePrice(scope.row)">查看历史直播价</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
    
    <!-- 调整记录组件 -->
    <adjustment-record 
      v-if="adjustmentVisible" 
      :visible.sync="adjustmentVisible" 
      :tablePropl="tablePropl" 
      :row="currentRow"
    />
  </content-panel>
</template>

<script>
import imgShow from '@/views/components/imgShow';
import customProps from './customProps.mixin';
import moment from 'moment';
import axios from '@/utils/axiosInstance';
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import AdjustmentRecord from './adjustment-record';

export default {
  name: 'SalesPriceQuery',
  components: { imgShow, AdjustmentRecord },
  mixins: [customProps, pagePathMixin, tableMixin],
  data() {
    return {
      searchForm: {
        skuCode: '',
        skuName: '',
        changeFlag: '',
        clearance: '',
        isCombination: '',
        boolLimit: '',
        startDate: '',
        endDate: '',
      },
      dateRange: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: 'auto',
      loading: false,
      styles: [],
      imgFormVisible: false,
      all: false,
      imgList: [],
      reportName: 'skuSalesPriceReport',
      isShowNew: 0,
      saleStatusList: [],
      adjustmentVisible: false,
      currentRow: {},
    };
  },
  computed: {
    tablePropl() {
      return this.columnData.map((v) => v.prop);
    },
  },
  methods: {
    onDateRangeChange(val) {
      if (val && val.length === 2) {
        this.searchForm.startDate = val[0];
        this.searchForm.endDate = val[1];
      } else {
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
    },
    lookRecord(row) {
      this.currentRow = row;
      this.adjustmentVisible = true;
    },
    lookLivePrice(row) {
      this.$router.push({
        path: '/goods/livePriceUphold',
        query: {
          startDate: this.searchForm.startDate,
          goodsCode: row.goodsCode,
        }
      })
    },
    searchPage() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
        },
      };
      this.$q.goods
        .listSalesPrice({
          data: param,
        })
        .then((res) => {
          if (res.code == 200 && res.data.records.length) {
            this.tableData = {
              ...res.data,
              list: this.formatTableData(res.data.records),
            };
          } else {
            this.tableData.list = [];
            this.tableData.total = 0;
          }
        }).finally(() => {
          this.loading = false;
        });
    },
    initSearchForm() {
      this.tableData.pageNum = 1;
      this.searchForm = {
        skuCode: '',
        skuName: '',
        changeFlag: '',
        clearance: '',
        isCombination: '',
        boolLimit: '',
        startDate: '',
        endDate: '',
      };
      this.dateRange = [];
    },
    resetForm() {
      this.initSearchForm();
      this.$nextTick((_) => {
        this.onSearch();
      });
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    saleStatusListChange(val) {
      this.all = val.length == this.saleStatusList.length;
      if (val.includes('')) {
        this.searchForm.saleStatusList = this.saleStatusList;
        this.all = true;
      } else if (val.includes('cancleAll')) {
        this.searchForm.saleStatusList = [];
        this.all = false;
      }
    },
    //导入
    importExcel() {
      this.openSubPage({
        path: '/goods/livePriceUpholdImport',
        query: {
          fileName: '商品直播价导入.xlsx',
          appCode: 'ec-pc-api',
          reportName: 'authorGoodsLivePriceImport',
        },
      });
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        taskDTO: {
          appCode: 'ec-pc-api',
          paramMap: this.searchForm,
          reportName: 'salesPriceExport',
        },
        columnDTOs: [],
      };
      let labels = this.columnData.map((v) => v.label);
      let props = this.columnData.map((v) => v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: 'string',
          columnFormat: null,
        });
      });
      // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== '图片');
      this.$q.common
        .customExportExcel({ data: params })
        .then((res) => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally((_) => {
          loading.close();
        });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.imgUrlList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },
    // tabldata 格式化 合并单元格
    formatTableData(data) {
      let list = [];
      data.forEach((v) => {
        if (v['goodsSaleList'].length) {
          let item = [];
          v['goodsSaleList'].forEach((k) => {
            let obj = k;
            obj['imgUrlList'] = v['imgUrlList'];
            obj['goodsCode'] = v['goodsCode'];
            obj['goodsName'] = v['goodsName'];
            item.push(obj);
          });
          list.push(...item);
        } else {
          list.push({
            imgUrlList: v['imgUrlList'],
            goodsCode: v['goodsCode'],
            goodsName: v['goodsName'],
            isAdd: '1',
          });
        }
      });
      return list;
    },
    // table 单元格合并
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      let goodsCodeArr = this.tableData.list.map((v) => v['goodsCode']);
      let arr = [];
      goodsCodeArr.forEach((item, index) => {
        if (index === 0) {
          arr.push({ goodsCode: 1 });
          return;
        }
        if (goodsCodeArr[index - 1] !== item) {
          arr.push({ goodsCode: 1 });
        } else {
          arr[arr.length - 1]['goodsCode']++;
        }
      });
      let newArr = [];
      arr.forEach((item, index) => {
        if (item.goodsCode > 1) {
          newArr.push(item);
          for (let i = 1; i < item.goodsCode; i++) {
            newArr.push({ goodsCode: null });
          }
        } else {
          newArr.push(item);
        }
      });
      if (columnIndex < 3 || columnIndex === 14) {
        if (newArr[rowIndex]['goodsCode']) {
          return {
            rowspan: newArr[rowIndex]['goodsCode'],
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getInventoy() {
      this.openSubPage({ path: '/goods/CommodityPriceChange', query: {} });
    },
    changeListSearch() {
      let data = {
        pageNum: 1,
        pageSize: 1,
        filterData: {},
      };
      this.searchFormData = data.filterData;
      this.$q.goods.changeListSearch({ data: data }).then((res) => {
        this.isShowNew = res.data.total;
      });
    },
    getSaleStatusList() {
      this.$q.goods.salesStatuslist({}).then((res) => {
        this.saleStatusList = res.data;
      });
    },
  },
  mounted() {
    this.onSearch();
    this.changeListSearch();
    this.getSaleStatusList();
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-dialog__body {
  padding: 10px 15px;
}

>>> .el-table__expanded-cell {
  padding: 10px;
  background: rgb(250, 250, 250);
}

.dialog-footer {
  text-align: center;
}

>>> .input .el-input__inner {
  width: 150px;
  height: 28px;
}

.table-wrap {
  padding: 10px;
  border-radius: 5px
}

>>> .badge_align .el-badge__content.is-fixed {
  width: auto;
  position: absolute;
  top: 0px;
  left: 0px;
  transform: translate(-70%, -50%);
}

.margin10 {
  margin-left: 10px
}

>>> .el-table .el-table__fixed {
    height:auto !important;
    bottom:11px;
}

>>> .el-table__fixed-right {
  height:auto !important;
  bottom:11px;
}


>>> .el-table__body-wrapper {
  &::-webkit-scrollbar { // 滚动条高 解决行未对齐
    height: 11px;
  }
}
>>> .el-table__fixed-body-wrapper .el-table__body {
  padding-bottom: 11px; // 滚动条高度

}
>>> .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
